/**
 * A "Call the Waiter" request.
 *
 * `cart: null` on an order does not mean the cart failed to load — it means
 * nothing was ordered, because the employee pressed the button that asks a
 * tea boy to come to them. It is a second kind of record travelling down the
 * same endpoint, and it needs to look like one: not an empty state, not a
 * fabricated cart line, and not a row that reads as broken data.
 *
 * Both the list cell and the detail card say it, so the words and the glyph
 * live here rather than being written twice.
 */
export const CALL_THE_WAITER = 'Call the Waiter';

export const CALL_THE_WAITER_TEXT = 'Nothing was ordered — the employee asked for a tea boy to come to them.';

/** A concierge bell. The design's icons are 24-viewBox line drawings. */
export const WaiterIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M3 18h18" />
    <path d="M5 18a7 7 0 0 1 14 0" />
    <path d="M12 4.6V6" />
    <circle cx="12" cy="3.2" r="1.2" />
  </svg>
);
